import { PieChart } from '@mui/x-charts/PieChart';
import { Card, CardContent, Typography } from '@mui/material';
import Loading from '../../components/loading';
import { useFinancialDashboardResource } from './hooks/useFinancialDashboardResource';

export function PaidExpensesVsReceivedIncomesPieChart({ selectedDate, viewByYear, viewAllPeriod }) {
  const { data: totals, isLoading } = useFinancialDashboardResource(
    '/financial/dashboard/paid-expenses-vs-received-incomes',
    { selectedDate, viewByYear, viewAllPeriod },
  );

  const data = [
    {
      id: 0,
      value: totals?.totalIncomes ?? '',
      label: `Entradas - ${totals?.totalIncomesFormatted ?? ''}`,
    },
    {
      id: 1,
      value: totals?.totalExpenses ?? '',
      label: `Saídas - ${totals?.totalExpensesFormatted ?? ''}`,
    },
  ];

  return (
    <Card sx={{ position: 'relative' }}>
      <Loading isToHidden={isLoading === false} />

      <CardContent>
        <Typography variant="h6" gutterBottom>
          Entradas vs Saídas
        </Typography>

        <PieChart
          series={[
            {
              data,
              innerRadius: 40,
              outerRadius: 100,
              paddingAngle: 3,
              arcLabel: (item) => `R$ ${item.value.toLocaleString('pt-BR')}`,
              arcLabelMinAngle: 10,
            },
          ]}
          height={250}
        />
      </CardContent>
    </Card>
  );
}
